import React from 'react';
import { Tree } from 'antd';
import { useRealmObjectContext } from '../contexts/RealmObjectProvider';
import useRealmTreeHandler from '../hooks/useRealmTreeHandler'; // Custom hook
import './css/RealmObjectsDisplay.css';
import './css/TreeControl.css';
import '../App.css';

const RealmObjectTree = ({ realmObject, deepExpand = false }) => {
  const { setRealmObjectID } = useRealmObjectContext();
  const {
    treeData,
    expandedKeys,
    setExpandedKeys,
    onDrop,
    onDragStart,
    onDragEnd
  } = useRealmTreeHandler();

  // helper: collect descendant keys (used if deepExpand=true)
  const collectDescendantKeys = (node) => {
    const out = [];
    const stack = [...(node.children || [])];
    while (stack.length) {
      const n = stack.pop();
      out.push(n.key);
      if (n.children && n.children.length) stack.push(...n.children);
    }
    return out;
  };

  const onSelect = (selectedKeys, info) => {
    if (selectedKeys?.length > 0) {
      setRealmObjectID(selectedKeys[0]);
    }

    // Auto-expand if the selected node is a parent
    if (info?.node?.children && info.node.children.length > 0) {
      const nodeKey = info.node.key;
      const keysToAdd = deepExpand
        ? [nodeKey, ...collectDescendantKeys(info.node)]
        : [nodeKey];

      setExpandedKeys((prev = []) => {
        const set = new Set(prev);
        keysToAdd.forEach((k) => set.add(k));
        return Array.from(set);
      });
    }
  };

  return (
    <Tree
      className="realm-object-tree"
      treeData={treeData}
      selectedKeys={[realmObject?.RealmObjectID]}
      expandedKeys={expandedKeys}
      onExpand={(keys) => setExpandedKeys(keys)}
      onSelect={onSelect}
      draggable
      onDrop={onDrop}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
    />
  );
};

export default RealmObjectTree;

